import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [bootLoading, setBootLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    localStorage.removeItem("fto_token");
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch {
      setAdmin(null);
    } finally {
      setBootLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAdmin(data.user);
    return data.user;
  };

  const loginWithGoogleSession = async (sessionId) => {
    const { data } = await api.post("/auth/google-session", { session_id: sessionId });
    setAdmin(data.user);
    return data.user;
  };

  const logout = async () => {
    setAdmin(null);
    try { await api.post("/auth/logout"); } catch { /* cookie already gone */ }
  };

  return (
    <AuthContext.Provider value={{ admin, login, loginWithGoogleSession, logout, bootLoading, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
